<script lang="ts">
	type Props = {
		id: string;
		value?: string;
		name: string;
		success?: boolean;
		error?: boolean;
		setValue?: (value: string) => void;
	};
	let { id, value = '', success = false, name, error = false, setValue }: Props = $props();

	const titles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr'];
	const valueChanged = () => {
		error = false;
		setValue?.(value);
	};
</script>

<div class="flex flex-wrap items-center">
	{#each titles as title}
		<div class="flex items-center space-x-2 py-2 pr-3">
			<input
				id={id + title}
				type="radio"
				bind:group={value}
				{name}
				class="input-radio b-1"
				value={title}
				onchange={valueChanged}
				checked={value === title}
				class:!border-red-500={error}
				class:dark:!border-red-300={error}
			/>
			<label
				for={id + title}
				class="font-semibold"
				class:!text-emmerald-500={success}
				class:!text-red-500={error}
				class:dark:!text-red-300={error}
				>{title}
			</label>
		</div>
	{/each}
</div>
